module.exports = __webpack_public_path__ + "img/P300T_Toon_Weapon_1013.882b06e2.png";